import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import TrackingPage from "./pages/TrackingPage";
import Services from "./pages/Services";
import About from "./pages/About";
import ContactForm from "./components/ContactForm";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/tracking" element={<TrackingPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactForm />} />
      </Routes>
    </Router>
  );
};

export default App;
